export const initialValues = {
  title: '',
  text: '',
  status: 1,
  // units: [],
  // users: [],
  // professional_type: { value: 'all', label: 'Todos' },
};
